import gql from 'graphql-tag';

export const UserDetailsQuery = gql`
	query UserDetails($accountIds: [String]) {
		confluenceUsers(accountIds: $accountIds) {
			nodes {
				displayName
				profilePicture {
					path
				}
				permissionType
				... on KnownUser {
					accountId
				}
			}
		}
	}
`;
